<!--
@Author: Ethan Dinnen
@Date:   2019-02-26 14:53:18
@Last Modified by:   Ethan Dinnen
@Last Modified time: 2019-02-27 13:36:23
-->

<template lang="pug">
  v-layout.disabled-alternate(row wrap)
    v-flex.pa-0(xs12)
      v-select(
        v-model='address.type'
        label='Address Type'
        :disabled="disabled"
        :items='types'
        @input="onInput"
        prepend-icon="home"
      )
    v-flex.pa-0.no-icon-field-indent(xs12)
      v-layout.my-0(row wrap)
        v-flex.py-0(xs12)
          v-text-field(
            browser-autocomplete="disable"
            :disabled="disabled"
            label='Address 1'
            v-model='address.street_address_1'
            @input="onInput"
          )
      v-layout.my-0(row wrap)
        v-flex.py-0(xs12)
          v-text-field(
            browser-autocomplete="disable"
            :disabled="disabled"
            label='Address 2'
            v-model='address.street_address_2'
            @input="onInput"
          )
      v-layout.my-0(row wrap)
        v-flex.py-0.pr-2(xs5)
          v-text-field(
            browser-autocomplete="disable"
            :disabled="disabled"
            label='City'
            v-model='address.city'
            @input="onInput"
          )
        v-flex.py-0.pr-2(xs4)
          v-text-field(
            browser-autocomplete="disable"
            :disabled="disabled"
            label='State'
            v-model='address.state'
            @input="onInput"
          )
        v-flex.py-0(xs3)
          v-text-field(
            browser-autocomplete="disable"
            :disabled="disabled"
            label='Zip'
            v-model='address.zip'
            @input="onInput"
          )
      div.text-xs-right(v-if="!disabled")
        v-btn.mr-0(flat outline color="primary" @click="onDelete" data-cy="remove-address")
          | Remove This Address
</template>

<script>
export default {
  props: {
    types: {
      type: Array,
    },
    value: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    address() {
      return Object.assign({}, this.value);
    },
  },
  methods: {
    onInput() {
      // Return without emitting if this is the first load or content is the same
      if (this.address === this.value) {
        return;
      }
      this.$emit('input', this.address);
    },
    onDelete() {
      this.$emit('delete', this.address);
    },
  },
};
</script>

<style scoped>
.v-text-field.v-input--is-disabled {
  height: 48px;
}
</style>
